import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';
import { LoggedUser } from './types';

interface LoginSuccess {
  token: string;
  accessValidity: string;
  user: LoggedUser;
}

export const authLoaders = getLoaders({
  linkVerify: {
    load: async (payload: { token: string }): Promise<LoginSuccess> => {
      return executeApiCall({
        path: '/login/link',

        payload,

        method: 'post',

        auth: false,
      });
    },
  },
});
